import React from "react";
import { UserCheck, ClipboardCheck, Clock } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OwnerOperatedOversightWhyUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [{
    title: "Owner-Operated Oversight",
    description: "We don't just send a crew; we lead them. Hands-on ownership means every job is inspected with a critical eye before we walk out the door.",
    icon: UserCheck
  }, {
    title: "Checklist-Based Precision",
    description: "We don't rely on memory. Our strict, checklist-driven system ensures consistent, high-level results every single time. No corner is cut.",
    icon: ClipboardCheck
  }, {
    title: "Uncompromising Punctuality",
    description: "Your time is respected. We communicate clearly, arrive when scheduled, and deliver professional reliability you can count on.",
    icon: Clock
  }];
  return <section id="owner-operated-oversightwhy-us" ref={ref} className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className={cn("mx-auto max-w-2xl text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-primary font-semibold tracking-wide uppercase text-sm mb-3">
            Why Choose Pure Detail
          </h2>
          <h3 className="text-foreground text-4xl font-bold tracking-tight sm:text-5xl font-serif">
            The Standard Is Higher Here.
          </h3>
          <p className="mt-6 text-lg leading-8 text-muted-foreground">
            We believe clean spaces create clarity. Our disciplined approach ensures that every detail reflects our pride in your home or business.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <div className="grid grid-cols-1 gap-x-8 gap-y-16 lg:grid-cols-3">
            {benefits.map((benefit, i) => <div key={benefit.title} data-index={i} className={cn("flex flex-col items-start bg-card p-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
            transitionDelay: `${150 * (i + 1)}ms`
          }}>
                <div className="flex items-center gap-x-3 w-full mb-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-none bg-primary/10">
                    <benefit.icon className="h-6 w-6 text-primary" aria-hidden="true" />
                  </div>
                  <h4 className="text-xl font-semibold leading-7 text-foreground">
                    {benefit.title}
                  </h4>
                </div>
                
                <Separator className="bg-secondary h-px w-full mb-6" />

                <div className="flex flex-col">
                  <p className="text-base leading-7 text-muted-foreground">
                    {benefit.description}
                  </p>
                  
                  <ul className="mt-6 space-y-2">
                    <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                      <span className="h-1.5 w-1.5 rounded-full bg-primary" />
                      <span>Pure Effort</span>
                    </li>
                    <li className="flex items-center gap-2 text-sm font-medium text-foreground">
                      <span className="h-1.5 w-1.5 rounded-full bg-primary" />
                      <span>Pure Pride</span>
                    </li>
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}